import React, { Component } from 'react';
import CameraResolutionTest from "../../webrtc-validator/camresolutiontest";
import TestCase from "./test_case";

export default class VideoTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoInputs: [],
      videoSelected: "",
      goNextState: false,
    };
    this.cameraResolutionTest = new CameraResolutionTest([[1280, 720]]);
    this.onDeviceSelectorChange = this.onDeviceSelectorChange.bind(this);
    this.onTestFinished = this.onTestFinished.bind(this);
  }

  componentDidMount() {
    // we get the media devices available
    let self = this;
    navigator.mediaDevices.enumerateDevices()
        .then(function(sourceInfos) {
          sourceInfos
              .filter(source => source.kind === "videoinput")
              .map(source => self.setState({ videoInputs: [...self.state.videoInputs, source] }));
        })
        .catch(function(err) {
          console.log('JS Device selection not supported', err);
        });
  }

  onDeviceSelectorChange(event) {
    this.setState({ videoSelected: event.target.value });
  }

  onTestFinished(testState) {
    this.setState({ goNextState: testState });
  }

  render() {
    return (
        <div>
          <h3 className={"text-center"}>Prueba de Video</h3>
          <h4 className='text-center'>Paso {this.props.currentStep} de {this.props.totalSteps}</h4>
          <p>
            Esta prueba, permitirá evaluar si el dispositivo de grabación de video de su computador, permitirá realizar
            una video-conferencia de calidad con otros usuarios. Para comenzar, Ud. deberá seleccionar un dispositivo de grabación
            de video de su computador. Normalmente el dispositivo se debería llamar <strong>"WebCam"</strong> o <strong>"default".</strong>
          </p>
          <p>
            La prueba consiste en capturar imágenes utilizando su dispositivo y evaluando la calidad de estas. Por esto, es
            importante que su cámara de video se encuentre disponible y grabando en un sitio con la adecuada iluminación.
            Una vez seleccionado el dispositivo, presione en el botón <strong>"Ejecutar Test"</strong>.
          </p>
          <div className={"form-group"}>
            <select value={this.state.videoSelected} onChange={this.onDeviceSelectorChange} className={"form-control"}>
              <option value="">Seleccionar dispositivo...</option>
              { this.state.videoInputs.map((device, idx) => <option key={idx} value={device.deviceId}>{device.label}</option>) }
            </select>
          </div>

          <TestCase device={this.state.videoSelected} runnable={this.cameraResolutionTest} onFinish={this.onTestFinished} />
          <button className='btn btn-primary btn-block' disabled={!this.state.goNextState} onClick={this.props.nextStep}>
            Siguiente
          </button>
        </div>
    );
  }
}
